import { isConvertibleExtension } from '@picsio/db/src/fileTypes';

/**
 * Whether the Copy / Download converter may resize this asset (format change,
 * locked width/height). Uses the same extension list as `isConvertibleFormat`.
 *
 * @param {string|undefined} fileExtension
 * @returns {boolean}
 */
export default function isResizeSupportedFormat(fileExtension) {
  return isConvertibleExtension(fileExtension);
}
